module.exports = __webpack_public_path__ + "img/curtain_horizontal_100.494e9ba6.svg";